module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/down-db122962435674c92884cecf44ae8c80.svg&quot;;"